import { useState, useEffect, useRef } from "react";
import Lenis from "lenis";
import Intro from "./Intro";
import Navbar from "./Navbar";
import Hero from "./Hero";
import {
  TrustStrip,
  Manifesto,
  Portfolio,
  Features,
  Quality,
  Kerala,
  Markets,
  Promise,
} from "./Sections";
import { BrandStory, TrustedPresence } from "./Extras";
import BrandPortfolio from "./BrandPortfolio";
import Compliance from "./Compliance";
import Contact from "./Contact";
import Footer from "./Footer";

export default function Landing() {
  // Intro plays only once per browser session. Returning to "/" from any
  // subpage (or reloading within the tab) skips straight to the content.
  const [introDone, setIntroDone] = useState(() => sessionStorage.getItem("av_intro_seen") === "1");
  const lenisRef = useRef(null);

  const handleIntroDone = () => {
    sessionStorage.setItem("av_intro_seen", "1");
    setIntroDone(true);
  };

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!introDone) {
      lenisRef.current?.stop();
      document.body.style.overflow = "hidden";
    } else {
      lenisRef.current?.start();
      document.body.style.overflow = "";
      lenisRef.current?.scrollTo(0, { immediate: true });
    }
  }, [introDone]);

  const scrollToContact = () =>
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="bg-[#F8F7F3]">
      {!introDone && <Intro onDone={handleIntroDone} />}
      <Navbar onQuote={scrollToContact} />
      <main>
        <Hero ready={introDone} onQuote={scrollToContact} />
        <TrustStrip />
        <BrandPortfolio />
        <Manifesto />
        <BrandStory />
        <Portfolio onQuote={scrollToContact} />
        <Features />
        <Quality />
        <Kerala />
        <Markets />
        <Compliance />
        <Promise />
        <TrustedPresence />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
